enum BUTTON_EFFECTS {
  RELOAD_PAGE = "reload-page",
  CHECKOUT_REDIRECT = "checkout-redirect",
}

const HELPERS = {
  isRebuyEnabled: function () {
    const { status } = window.Rebuy.SmartCart;
    return status !== "disabled";
  },
};

export const handleButtonEffect = (node: HTMLElement) => {
  const effect = node.dataset.effect;
  if (!effect) return;
  switch (effect) {
    case BUTTON_EFFECTS.RELOAD_PAGE:
      reloadPage();
      break;
    case BUTTON_EFFECTS.CHECKOUT_REDIRECT:
      checkoutRedirect();
      break;
    default:
      break;
  }
};

const reloadPage = () => {
  if (HELPERS.isRebuyEnabled()) return;
  try {
    location.reload();
  } catch (e) {
    console.error(e);
  }
};

const isMobile = () => {
  return /iPhone|iPad|iPod|Android|webOS|BlackBerry|Windows Phone/i.test(
      navigator.userAgent
  );
}

const checkoutRedirect = () => {
  if (HELPERS.isRebuyEnabled()) {
    const cartFlyout = document.querySelector<HTMLElement>('#rebuy-cart .rebuy-cart__flyout');
    if (cartFlyout) {
      cartFlyout.style.display = 'none';
    }
  }

  setTimeout(() => {
    window.location.href = '/checkout';
  }, isMobile() ? 1000 : 2000);
};

